import { render, staticRenderFns } from "./BlogNav.vue?vue&type=template&id=7b151b44&scoped=true"
import script from "./BlogNav.vue?vue&type=script&lang=js"
export * from "./BlogNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b151b44",
  null
  
)

export default component.exports